// Las 24 provincias con el código de una letra que usa Correo (ISO 3166-2:AR).
//
// ⚠ Espejo de la tabla PROVINCIAS de server/utils/correo/translate.js. El
// backend traduce el nombre al código y RECHAZA lo que no reconoce, así que
// lo que se pueda elegir acá tiene que existir allá: por eso los nombres se
// escriben igual (el backend compara sin tildes y en minúsculas, pero la
// lista tiene que ser la misma). Si se agrega una, va en los dos lados.
export type Provincia = { codigo: string; nombre: string };

export const PROVINCIAS: Provincia[] = [
  { codigo: "B", nombre: "Buenos Aires" },
  { codigo: "C", nombre: "Ciudad Autónoma de Buenos Aires" },
  { codigo: "K", nombre: "Catamarca" },
  { codigo: "H", nombre: "Chaco" },
  { codigo: "U", nombre: "Chubut" },
  { codigo: "X", nombre: "Córdoba" },
  { codigo: "W", nombre: "Corrientes" },
  { codigo: "E", nombre: "Entre Ríos" },
  { codigo: "P", nombre: "Formosa" },
  { codigo: "Y", nombre: "Jujuy" },
  { codigo: "L", nombre: "La Pampa" },
  { codigo: "F", nombre: "La Rioja" },
  { codigo: "M", nombre: "Mendoza" },
  { codigo: "N", nombre: "Misiones" },
  { codigo: "Q", nombre: "Neuquén" },
  { codigo: "R", nombre: "Río Negro" },
  { codigo: "A", nombre: "Salta" },
  { codigo: "J", nombre: "San Juan" },
  { codigo: "D", nombre: "San Luis" },
  { codigo: "Z", nombre: "Santa Cruz" },
  { codigo: "S", nombre: "Santa Fe" },
  { codigo: "G", nombre: "Santiago del Estero" },
  { codigo: "V", nombre: "Tierra del Fuego" },
  { codigo: "T", nombre: "Tucumán" },
];
